import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {Observable, map, } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APIResponse } from 'src/app/shared/data-access/api-response.model';
import {RoleModel} from "./role.model";
import {SubjectsModel} from "./subjects.model";
import {UnitsModel} from "./units.model";
import {OrganizationsModel} from "./organizations.model";
import {Course} from "./course.model";
import {RoleTempInterface} from "../../dashboard/userProfile/userProfile.component";
import {catchApiError, catchErrorWith} from "../../shared/utils/api-error";
import {encodeParam} from "../../shared/utils/query-string";
@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private httpClient = inject(HttpClient);

  listAllUserRoles(): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/organization/roles/listall`;

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  listAllPermissions(): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/organization/roles/permissions/listall`;

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  createRole(name: string, description: string, permissionIDs: string[], organizationIDs: string[], subjectIDs: string[], unitIDs: string[]): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/organization/roles/create`;

    let body = new HttpParams()
      .set('name', name)
      .set('description', description)
      .set('orgs', organizationIDs.join(', '))
      .set('subjects', subjectIDs.join(', '))
      .set('units', unitIDs.join(', '))
      .set('permissions', permissionIDs.join(', '));


    return this.httpClient.post<APIResponse>(apiUrl, body).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  updateRole(name: string, description: string, permissionIDs: string[], organizationIDs: string[], subjectIDs: string[], unitIDs: string[], roleID: string): Observable<APIResponse> {
    const apiUrl = `${environment.nodeUrl}/organization/roles/update`;

    const role = this.convertRoleJSON(name, description, permissionIDs, organizationIDs, subjectIDs, unitIDs, roleID);

    const body = new HttpParams()
      .set('role_id', roleID)
      .set('name', name)
      .set('description', description)
      .set('orgs', organizationIDs.join(', '))
      .set('subjects', subjectIDs.join(', '))
      .set('units', unitIDs.join(', '))
      .set('permissions', permissionIDs.join(', '));

    return this.httpClient.put<APIResponse>(apiUrl, body).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  updateRoleDescription(role_id: number, description: string): Observable<APIResponse> {
    const apiUrl = `${environment.nodeUrl}/organization/roles/update/description?role_id=${encodeParam(role_id)}`;

    const body = new HttpParams().set('description', description)

    return this.httpClient.put<APIResponse>(apiUrl, body).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  convertRoleJSON(name: string, description: string, permissionIDs: string[], organizationIDs: string[], subjectIDs: string[], unitIDs: string[], roleID?: string) {
    let permissionJSON = [];
    let orgJSON = [];
    let subjectJSON = [];
    let unitJSON = [];

    for(let i = 0; i < permissionIDs.length; i++) {
      permissionJSON.push({"permission_id":permissionIDs[i]})
    }
    for(let i = 0; i < organizationIDs.length; i++) {
      orgJSON.push({"organization_id":organizationIDs[i]})
    }
    for(let i = 0; i < subjectIDs.length; i++) {
      subjectJSON.push({"subject_id":subjectIDs[i]})
    }
    for(let i = 0; i < unitIDs.length; i++) {
      unitJSON.push({"unit_id":unitIDs[i]})
    }
    if(roleID != null)
      return {
        name: name,
        description: description,
        permissions: permissionJSON,
        organizations: orgJSON,
        subjects: subjectJSON,
        units: unitJSON,
        role_id: roleID
      }
    else
      return {
        name: name,
        description: description,
        permissions: permissionJSON,
        organizations: orgJSON,
        subjects: subjectJSON,
        units: unitJSON
      }
  }

  retireRole(roleID: number): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/organization/roles/retire`;

    let body = new HttpParams()
      .set('role_id', roleID)

    return this.httpClient.delete<APIResponse>(apiUrl, {body: body}).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  getRoleDetail(roleID: string): Observable<APIResponse> {
    const apiUrl = `${environment.nodeUrl}/organization/roles/details?role_id=${encodeParam(roleID)}`;

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  // TODO implement list role context
  //listRoleContext(): Observable<APIResponse> {

  //}

  listAllSubjectAndUnits(): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/organization/subjects/units/listall`;

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  removeRole(email: string, role: RoleTempInterface): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/organization/users/roles/remove?user_email=${encodeParam(email)}&role_id=${encodeParam(role.role_id)}&organization_id=${encodeParam(role.organization_id)}&subject_id=${encodeParam(role.subject_id)}&unit_id=${encodeParam(role.unit_id)}&course_id=${encodeParam(role.course_id)}`;

    return this.httpClient.post<APIResponse>(apiUrl, {}).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  addRole(email: string, role: RoleTempInterface): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/organization/users/roles/assign?user_email=${encodeParam(email)}&role_id=${encodeParam(role.role_id)}&organization_id=${encodeParam(role.organization_id)}&subject_id=${encodeParam(role.subject_id)}&unit_id=${encodeParam(role.unit_id)}&course_id=${encodeParam(role.course_id)}`;

    return this.httpClient.post<APIResponse>(apiUrl, {}).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  assignOrRemoveRole(email: string, roleID: string, subjectIDs?: SubjectsModel[], unitIDs?: UnitsModel[], orgID?: OrganizationsModel[], courseID?: Course[], remove?: boolean): Observable<boolean> {
    let subjectJSON = `&subject_id=`
    let unitJSON = `&unit_id=`
    let orgJSON = `&organization_id=`
    let courseJSON = `&course_id=`

    if(subjectIDs != null)
      for(let i = 0; i < subjectIDs.length; i++) {
        if(subjectIDs[i].subject_id != null) {
          subjectJSON += `${subjectIDs[i].subject_id}`
          if (i + 1 !== subjectIDs.length)
            subjectJSON += `,`
        }
      }
    if(unitIDs != null)
      for(let i = 0; i < unitIDs.length; i++) {
        if(unitIDs[i].unit_id != null) {
          unitJSON += `${unitIDs[i].unit_id}`
          if (i + 1 !== unitIDs.length)
            unitJSON += `,`
        }
      }
    if(orgID != null)
      for(let i = 0; i < orgID.length; i++) {
        if(orgID[i].organization_id != null) {
          orgJSON += `${orgID[i].organization_id}`
          if(i + 1 !== orgID.length)
            orgJSON += `,`
        }
      }
    if(courseID != null) {
      for(let i = 0; i < courseID.length; i++) {
        courseJSON += `${courseID[i].course_id}`
        if(i + 1 !== courseID.length)
          courseJSON += ','
      }
    }
    let paramString = `user_email=${encodeParam(email)}&role_id=${encodeParam(roleID)}`;
    if(subjectIDs != null && subjectIDs.length > 0)
      paramString = `${paramString}${subjectJSON}`;
    if(unitIDs != null && unitIDs.length > 0)
      paramString = `${paramString}${unitJSON}`;
    if(orgID != null && orgID.length > 0)
      paramString = `${paramString}${orgJSON}`
    if(courseID != null && courseID.length > 0)
      paramString = `${paramString}${courseJSON}`
    let apiUrl = `${environment.baseUrl}/organization/users/roles/`;
    if(!remove)
      apiUrl = `${apiUrl}assign?${paramString}`
    else
      apiUrl = `${apiUrl}remove?${paramString}`

    return this.httpClient.post<APIResponse>(apiUrl, {}).pipe(
      map((response) => {
        return response.success
      }),
      catchErrorWith(false)
    )
  }

  addAdaTime(user_id: number, title: string, orgID: string, timeMult?: number, timeAdd?: number): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/organization/users/accommodations/time/assign?user_id=${encodeParam(user_id)}&org_id=${encodeParam(orgID)}&title=${encodeParam(title)}`;

    if(timeMult != null)
      apiUrl = `${apiUrl}&time_multiplier=${encodeParam(timeMult)}`
    if(timeAdd != null)
      apiUrl = `${apiUrl}&time_addition=${encodeParam(timeAdd)}`

    return this.httpClient.post<APIResponse>(apiUrl, {}).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  deleteAdaTime(user_email: string, course_id: string): Observable<boolean> {
    const apiUrl = `${environment.baseUrl}/organization/users/accommodations/time/remove?user_email=${encodeParam(user_email)}&course_id=${encodeParam(course_id)}`

    return this.httpClient.post<APIResponse>(apiUrl, {}).pipe(
      map((response) => {
        return response.success
      }),
      catchErrorWith(false)
    )
  }

  listRoleAssignees(role_id: string): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/organization/roles/users/list?role_id=${encodeParam(role_id)}`

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  listCourses(unit_id?: string): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/course/list/currentfuture`
    if(unit_id != null)
      apiUrl = `${apiUrl}?unit_id=${encodeParam(unit_id)}`

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  getRoleScope(role_id: number): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/organization/roles/scopes?role_id=${encodeParam(role_id)}`

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }
}
